import { render } from "./SubjectHtmlContent.vue?vue&type=template&id=30c15c4d"
import script from "./SubjectHtmlContent.vue?vue&type=script&lang=js"
export * from "./SubjectHtmlContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__